<template>
    <div>
        <Breadcrumb section-name="Order" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-header text-center">
                    <h5 class="mt-2">Raw Material Purchase Order</h5>
                </div>
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <div class="row">
                        <div class="col-md-6">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <td>Order Date</td>
                                    <th>{{ addEditParam.order_date }}</th>
                                </tr>
                                <tr>
                                    <td>Order Number</td>
                                    <th>{{ addEditParam.order_date }}</th>
                                </tr>
                                <tr>
                                    <td>Order Quantity</td>
                                    <th>{{ addEditParam.order_quantity }}</th>
                                </tr>
                                <tr>
                                    <td>Customer Name</td>
                                    <th>{{ addEditParam.customer_name }}</th>
                                </tr>
                                <tr>
                                    <td>Customer Address</td>
                                    <th>{{ addEditParam.customer_address }}</th>
                                </tr>
                                <tr>
                                    <td>Customer Contract No</td>
                                    <th>{{ addEditParam.customer_contact_number }}</th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                        <div class="col-md-6">
                            <a class="me-2 btn btn-option mb-2 float-end" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="pdf" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status"
                                      aria-hidden="true"></span>
                            </a>
                        </div>
                    </div>
                    <h5>Raw Material Requisition</h5>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>SI</th>
                                <th>Raw Material Name</th>
                                <th>Unit</th>
                                <th class="text-center">Quantity</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(each,index) in addEditParam.items">
                                <td v-text="index + 1"></td>
                                <td v-text="each.raw_material_name"></td>
                                <td v-text="each.unit_name"></td>
                                <td class="text-center" v-text="each.quantity"></td>
                                <td v-text="each.description"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumb from "../Common/Breadcrumb.vue";
import Table from "../Common/Table.vue";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";

export default {
    name: "Purchase Order",
    components: {Table, Breadcrumb},
    data() {
        return {
            breadCrumb: ['Purchase Order'],
            loading: false,
            dataLoading: false,
            addEditParam: {

            },
            rawMaterials: [],
            exportLoading: false,
        }
    },
    methods: {
        downloadFile: function () {
            this.exportLoading = true;
            let route = ApiRoutes.Order  + '/export/purchase-order'
            let name = 'purchase-order.pdf'
            ApiService.DOWNLOAD(route, {id: this.$route.params.id},'',res => {
                this.exportLoading = false;
                let blob = new Blob([res], {type: 'application/pdf'});
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = name;
                link.click();
            });
        },
        fetchSingleOrder: function() {
            ApiService.POST(ApiRoutes.Order + '/single', {id: this.$route.params.id}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.addEditParam = res.data;
                }
            });
        },
    },
    mounted() {
        this.fetchSingleOrder();
    }
}
</script>
<style scoped>

</style>
